import "./index.scss";

const AmenityList = ({
  name,
  amenities,
}: {
  name: string;
  amenities: string[];
}) => {
  const amenityNodes = amenities.map((amenity, index) => {
    return (
      <li className="amenity" key={amenity}>
        <div className="amenity-inner-wrapper">{amenity}</div>
      </li>
    );
  });

  return (
    <div className="component amenity-list">
      <h2 className="amenity-list-header">{name}</h2>
      <ul>{amenityNodes}</ul>
    </div>
  );
};
export default AmenityList;
